import { useSettings } from './useSettings';

/** Is the current org in safe mode?? */
export function useIsSafeMode() {
  const { data: settings } = useSettings();

  return !settings?.active;
}
